<template>
  <div class="advice" >
    <el-divider content-position="left">建议列表</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchForm.companyId"
        filterable
        remote
        reserve-keyword
        placeholder="请输入公司名称筛选公司"
        size="mini"
        clearable
        :remote-method="searchRemoteCompanyMethodS"
        :loading="searchLoading"
        @change="toSearch"
      >
        <el-option
          v-for="searchCompany in searchCompaniesx"
          :key="searchCompany.id"
          :label="searchCompany.company_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="margin-left: 0.2rem">
        <el-checkbox-group v-model="onlyMe" size="mini" @change="submitOM">
          <el-checkbox :label="'om'" border>仅展示我服务的公司</el-checkbox>
        </el-checkbox-group>
      </div>
      <el-popover placement="bottom" width="300" trigger="click" v-model="visible">
        <el-form
          ref="searchForm"
          :model="searchForm"
          label-width="80px"
          style="padding-right: 0.23rem"
        >
          <el-form-item label="选择月份" prop="month">
            <el-date-picker
              v-model="searchForm.month"
              type="month"
              placeholder="选择月份"
              size="mini"
              value-format="yyyy-MM"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="建议人" prop="advice_name">
            <el-cascader
                style="width: 100%;"
                v-model="searchForm.advice_name"
                placeholder="请选择"
                :options="adviceNameOptions"
                size="mini"
                @click.native="loadAdvice"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
                >
              </el-cascader>
          </el-form-item>
          <el-form-item label="建议类型" prop="advice_cate">
            <el-select
              v-model="searchForm.advice_cate"
              clearable
              placeholder="请选择"
              size="mini"
              filterable
              @click.native="loadAdviceCate"
              style="width: 100%"
            >
              <el-option
                v-for="item in adviceCateOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否阅读" prop="is_read">
            <el-radio-group v-model="searchForm.is_read" size="mini">
              <el-radio-button :label="'0'">未阅读</el-radio-button>
              <el-radio-button :label="1">已阅读</el-radio-button>
              <el-radio-button :label="2">未知</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否认同" prop="is_agree">
            <el-radio-group v-model="searchForm.is_agree" size="mini">
              <el-radio-button :label="'0'">不认同</el-radio-button>
              <el-radio-button :label="1">认同</el-radio-button>
              <el-radio-button :label="2">未知</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="采纳案例" prop="is_use">
            <el-radio-group v-model="searchForm.is_use" size="mini">
              <el-radio-button :label="1">是</el-radio-button>
              <el-radio-button :label="'0'">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <div style="text-align: right">
            <el-button type="info" @click="resetForm('searchForm')" size="mini"
              >重置</el-button
            >
            <el-button type="primary" @click="doSearch" size="mini"
              >查询</el-button
            >
          </div>
        </el-form>
        <el-button slot="reference" size="mini" style="margin-left: 10px"
          >筛选</el-button
        >
      </el-popover>
      <el-popover placement="bottom" width="300" trigger="click">
        <el-table
          max-height="650"
          :data="wonderfulData"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
        >
          <el-table-column prop="id" label="序号" width="80" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="advice_name" label="精彩榜" align="center">
          </el-table-column>
          <el-table-column prop="total" label="数量" align="center">
          </el-table-column>
        </el-table>
        <el-button
          slot="reference"
          icon="el-icon-medal-1"
          size="mini"
          style="margin-left: 10px"
          type="danger"
          @click="getWonderful"
        >
          精彩榜
        </el-button>
      </el-popover>
      <el-popover placement="bottom" width="300" trigger="click">
        <el-table
          max-height="510"
          :data="agreeData"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
        >
          <el-table-column prop="id" label="序号" width="80" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="advice_name" label="认同榜" align="center">
          </el-table-column>
          <el-table-column prop="total" label="数量" align="center">
          </el-table-column>
        </el-table>
        <el-button
          slot="reference"
          icon="el-icon-document-checked"
          size="mini"
          style="margin-left: 10px"
          type="warning"
          @click="getAgree"
        >
          认同榜
        </el-button>
      </el-popover>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="categoryIn"
          >录入</el-button
        >
      </div>
    </div>
    <el-row style="margin-top: 0.2rem">
      <el-col :span="2"> 累计建议:{{ countAdvice }} </el-col>
      <el-col :span="2"> 客户阅读:{{ countRead }} </el-col>
      <el-col :span="2"> 客户认同:{{ countAgree }} </el-col>
      <el-col :span="2"> 客户反对:{{ countNotAgree }} </el-col>
    </el-row>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleCloseIn"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryForm"
          :rules="rules"
          ref="categoryForm"
          label-width="100px"
        >
          <el-form-item label="公司名称" prop="companyId">
            <el-select
              v-model="categoryForm.companyId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入公司名称筛选公司"
              size="mini"
              clearable
              :remote-method="searchRemoteCompanyMethod"
              :loading="searchLoading"
              style="width: 100%"
            >
              <el-option
                v-for="searchCompany in searchCompanies"
                :key="searchCompany.id"
                :label="searchCompany.company_name"
                :value="searchCompany.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类名称" prop="categoryId">
            <el-select
              size="mini"
              v-model="categoryForm.categoryId"
              clearable
              placeholder="请选择分类"
              style="width: 100%"
              @click.native="getCate"
              filterable
            >
              <el-option
                v-for="item in cateOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="建议内容" prop="body">
            <el-input
              size="mini"
              type="textarea"
              v-model="categoryForm.body"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传截图" prop="url">
            <el-upload
              action="https://weixin.qiyehuo.com/api/advice/upscr"
              :headers="header"
              multiple
              ref="uploadMutiple"
              list-type="picture-card"
              :file-list="fileList"
              :limit="limit"
              accept="image/jpeg,image/jpg,image/png"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :on-change="handleAvatarChange"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div style="margin-top: 0.2rem">
              <span
                ><i class="el-icon-s-opportunity" style="color: #fb894c"
                  >点击下方，Ctrl+v上传</i
                ></span
              >
            </div>
            <!-- <div id="preview" @paste="handlePaste">
              <el-input
                size="mini"
                type="textarea"
                placeholder="先点击此处 再按Ctrl+V 粘贴至此处"
                max="0"
              ></el-input>
            </div> -->
            <div
              id="preview"
              @paste="handlePaste"
              style="
                border: 3px dashed #409eff;
                border-radius: 15px;
                text-indent: 2em;
              "
            >
              <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
            </div>
            <el-dialog :visible.sync="dialogVisible" :modal="false">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('categoryForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryEditForm"
          :rules="rules"
          ref="categoryEditForm"
          label-width="100px"
        >
          <el-form-item label="公司名称" style="margin-top: -0.4rem">
            <span style="font-size: 0.28rem">{{ other.company_name }}</span>
          </el-form-item>
          <el-form-item label="月份" style="margin-top: -0.4rem">
            <span style="font-size: 0.25rem">{{ other.month }}</span>
          </el-form-item>
          <el-form-item
            label="分类名称"
            prop="categoryId"
            style="margin-top: -0.4rem"
          >
            <!-- <el-select
              v-model="categoryEditForm.categoryId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入搜索分类名称"
              size="mini"
              clearable
              :remote-method="searchRemoteCfbodyEdit"
              :loading="searchLoading"
              style="width: 100%"
            >
              <el-option
                v-for="searchCompany in searchEditBodies"
                :key="searchCompany.id"
                :label="searchCompany.category_name"
                :value="searchCompany.id"
              >
              </el-option>
            </el-select> -->
            <el-select
              size="mini"
              v-model="categoryEditForm.categoryId"
              clearable
              placeholder="请选择分类"
              style="width: 100%"
              @click.native="getCateEdit"
              filterable
            >
              <el-option
                v-for="item in cateEditOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="建议内容" prop="body">
            <el-input
              size="mini"
              type="textarea"
              v-model="categoryEditForm.body"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传截图" prop="url">
            <el-upload
              action="https://weixin.qiyehuo.com/api/advice/upscr"
              :headers="header"
              multiple
              ref="editUploadMutiple"
              list-type="picture-card"
              :file-list="editFileList"
              :limit="limit"
              accept="image/jpeg,image/jpg,image/png"
              :before-upload="beforeAvatarUpload"
              :on-success="editHandleAvatarSuccess"
              :on-change="editHandleAvatarChange"
              :on-preview="editHandlePictureCardPreview"
              :on-remove="editHandleRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div style="margin-top: 0.2rem">
              <span
                ><i class="el-icon-s-opportunity" style="color: #fb894c"
                  >点击下方，Ctrl+v上传</i
                ></span
              >
            </div>
            <!-- <div id="preview" @paste="handlePaste">
              <el-input
                size="mini"
                type="textarea"
                placeholder="先点击此处 再按Ctrl+V 粘贴至此处"
                max="0"
              ></el-input>
            </div> -->
            <div
              id="previewE"
              @paste="editHandlePaste"
              style="
                border: 3px dashed #409eff;
                border-radius: 15px;
                text-indent: 2em;
              "
            >
              <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
            </div>
            <el-dialog :visible.sync="dialogVisibleE" :modal="false">
              <img width="100%" :src="dialogImageUrlE" alt="" />
            </el-dialog>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('categoryEditForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="阅读记录"
      :visible.sync="categoryReadDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-timeline style="height: 26rem; overflow: auto">
          <el-timeline-item
            v-for="r in fileReadRecOptions"
            :timestamp="r.created_at"
            placement="top"
            :key="r.id"
          >
            <el-card>
              <!-- <h4>更新 Github 模板</h4> -->
              <p>{{ r.reader }}, 在{{ r.created_at }}, 阅读了{{ r.title }}。</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyComId"></company-info>
        </el-row>
      </div>
    </el-drawer>

    <el-table
    height="calc(100vh - 306px)"
      :data="categoryData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column
        prop="company_name"
        label="公司名称"
        width="250"
        fixed="left"
      >
        <template slot-scope="scope">
          <el-link
            style="color: #409eff; font-size: 0.28rem; cursor: pointer"
            @click="openCompanyCom(scope.row)"
          >
            {{ scope.row.company_name }}
          </el-link>
          <el-tooltip class="item" effect="dark" content="复制" placement="top"><i class="el-icon-document-copy" style="margin-left:0.1rem;cursor:pointer" @click="copySome(scope.row.company_name)"></i></el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="cate_name">
        <template slot="header">
          类型
          <span>
            <a href="/advice_cate">
              <el-link style="color: #409eff; margin-left: 0.4rem"
                >添加类型</el-link
              >
            </a>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="月份" width="140"> 
        <template slot-scope="scope" >
          <date-formatter :date-value="scope.row.created_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column prop="advice_name" label="建议人"> </el-table-column>
      <el-table-column prop="is_read" label="客户阅读" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.is_read === '已阅读'">
            <!-- {{ scope.row.readed_at }} -->
            <date-formatter :date-value="scope.row.readed_at"></date-formatter>
          </span>
          <span v-else>
            {{ scope.row.is_read }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="is_agree" label="客户认同" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.is_agree === '认同'">
            认同，认同时间：<br />
            <!-- {{ scope.row.agreed_at }} -->
            <date-formatter :date-value="scope.row.agreed_at"></date-formatter>
          </span>
          <span v-else-if="scope.row.is_agree === '不认同'">
            反对，反对时间：<br />
            <!-- {{ scope.row.disagreed_at }} -->
            <date-formatter :date-value="scope.row.disagreed_at"></date-formatter>
          </span>
          <span v-else>
            {{ scope.row.is_agree }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <el-table-column label="编辑" align="center" fixed="right">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="修改"
              placement="top"
            >
              <el-button
                @click.native.prevent="editRow(scope.$index, categoryData)"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                circle
              >
              </el-button>
            </el-tooltip>
            <!-- <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
            >
              <el-button
                @click.native.prevent="deleteRow(scope.$index, categoryData)"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
              >
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="阅读记录"
              placement="top"
            >
              <el-button
                @click.native.prevent="readRow(scope.$index, categoryData)"
                type="success"
                size="mini"
                icon="el-icon-notebook-2"
                circle
              >
              </el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
        <el-table-column label="设为案例" align="center" fixed="right">
          <template slot-scope="scope">
            <el-radio-group
              v-model="ifuse[scope.$index]"
              size="mini"
              @change="setRow($event, scope.row)"
            >
              <el-radio-button :label="1">是</el-radio-button>
              <el-radio-button :label="'0'">否</el-radio-button>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <div class="page-footer">
      <el-pagination
      class="pagination-style"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import CompanyInfo from 'common/CompanyInfo'
import DateFormatter from 'common/DateFormatter'
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: 'Advice',
  components: { CompanyInfo, DateFormatter },
  data () {
    var categoryId = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入分类名称！'))
      }
      callback()
    }
    var checkbody = (rule, value, callback) => {
      if (value.length > 500) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入建议内容！'))
      }
      callback()
    }
    var checkCompany = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择公司！'))
      }
      callback()
    }
    return {
      visible: false,
      searchArr: {
        title: ''
      },
      searchForm: {
        advice_name: '',
        advice_cate: '',
        is_read: '',
        is_agree: '',
        month: '',
        companyId: '',
        is_use: ''
      },
      needUrl: [],
      editNeedUrl: [],
      npage: 1,
      categoryPerPage: 30,
      total: null,
      categoryData: [],
      searchTitles: [],
      searchBodies: [],
      searchEditBodies: [],
      roleOptions: [],
      cateOptions: [],
      cateEditOptions: [],
      roleEditOptions: [],
      dateCountData: [],
      agreeData: [],
      wonderfulData: [],
      fileReadRecOptions: [],
      onlyMe: [],
      searcher: null,
      categoryEditDrawer: false,
      categoryReadDrawer: false,
      searchLoading: false,
      searchCompanies: [],
      searchCompaniesx: [],
      searchCategories: [],
      categoryIndrawer: false,
      countSuccess: 0,
      editIfDisplay: false,
      direction: 'rtl',
      category: '',
      ideCateId: null,
      ifdisplay: false,
      companyInfoDrawer: false,
      companyComId: null,
      countAdvice: '',
      countRead: '',
      countAgree: '',
      countNotAgree: '',
      change: false,
      api: 'api/advice/upscr',
      header: {
        Authorization: localStorage.getItem('token')
      },
      limit: 3,
      formData: {},
      fileList: [],
      editFileList: [],
      dialogImageUrl: '',
      dialogImageUrlE: '',
      dialogVisible: false,
      dialogVisibleE: false,
      adviceNameOptions: [],
      adviceCateOptions: [],
      ifuse: [],
      categoryForm: {
        categoryId: '',
        body: '',
        companyId: ''
      },
      other: {
        company_name: '',
        month: ''
      },
      categoryEditForm: {
        categoryId: '',
        body: '',
        companyId: ''
      },
      editCategoryForm: {
        categoryId: '',
        category_name: ''
      },
      rules: {
        categoryId: [
          {
            validator: categoryId,
            trigger: 'blur'
          }
        ],
        body: [
          {
            validator: checkbody,
            trigger: 'blur'
          }
        ],
        companyId: [
          {
            validator: checkCompany,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
    this.loadCategory()
    this.loadAdvice()
    this.loadAdviceCate()
  },
  // watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  methods: {
    // 复制功能
    copy (data) {
      // 存储传递过来的数据
      let OrderNumber = data
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement('input')
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput)
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select()
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand('Copy')
      // 清空输入框
      newInput.remove()
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    copySome (data) {
      this.copy(data)
    },
    loadAdviceCate () {
      this.$axios
        .get('api/advice/getcate')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.adviceCateOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadAdvice () {
      this.$axios
        // .get('api/expmanage/getreceiver')
        .get('api/admin/user/branch')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.adviceNameOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadCategory () {
      this.$axios
        .get('api/advice/getcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.cateEditOptions = data.data
          }
        })
        .catch()
    },
    loadTable () {
      this.$axios
        .get('api/advice/index', {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searchForm,
            onlyMe: this.onlyMe
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data
            this.total = data.data.total
            this.countAdvice = data.data.total
            this.countRead = data.count.countRead
            this.countAgree = data.count.countAgree
            this.countNotAgree = data.count.countNotAgree
            this.setExa()
          }
        })
        .catch()
    },
    setExa () {
      this.categoryData.map((item, index) => {
        if (item.is_use === 1) {
          this.ifuse[index] = 1
        } else {
          this.ifuse[index] = 0
        }
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    editRow (index, data) {
      this.editFileList = []
      this.$axios
        .get('api/advice/show', {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.other.company_name = data.data.company_name
            this.other.month = data.data.month
            this.categoryEditForm.categoryId = data.data.cate.cate_id
            this.ideCateId = data.data.cate.cate_id
            this.categoryEditForm.body = data.data.body
            this.category = data.data.id
            var fileUrl = data.data.file.map(item => {
              return item
            })
            this.editFileList = fileUrl
          }
        })
        .catch()
      this.categoryEditDrawer = true
    },
    readRow (index, data) {
      this.$axios
        .get('api/advice/getrecord', {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.fileReadRecOptions = data.data
          }
        })
        .catch()
      this.categoryReadDrawer = true
    },
    deleteRow (index, data) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$axios
            .delete('api/advice/del', {
              params: {
                id: data[index].id
              }
            })
            .then(({ data }) => {
              if (data.code === 1) {
                this.loadTable()
                this.$message.success(data.msg)
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/advice/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    searchRemoteCfTitle (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItemTitle(query)
        }, 200)
      } else {
        this.searchtitles = []
      }
    },
    searchItemTitle (query) {
      this.$axios
        .get('api/advice/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchTitles = data.data
          }
        })
        .catch()
    },
    searchRemoteCfbody (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItemBody(query)
        }, 200)
      } else {
        this.searchBodies = []
      }
    },
    searchItemBody (query) {
      this.$axios
        .get('api/cloudfile/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchBodies = data.data
          }
        })
        .catch()
    },
    searchRemoteCfbodyEdit (query) {
      if (query !== '') {
        this.ideCateId = null
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItemBodyEdit(query)
        }, 200)
      } else {
        this.searchEditBodies = []
      }
    },
    searchItemBodyEdit (query) {
      this.$axios
        .get('api/cloudfile/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchEditBodies = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    handleSearchCfTitle (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    handleSearchCfBody (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    categoryIn () {
      this.categoryIndrawer = true
    },
    handleCloseIn (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.$refs.categoryForm.resetFields()
          this.$refs.uploadMutiple.clearFiles()
          this.needUrl = []
          done()
        })
        .catch(_ => {})
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.editFileList = []
          done()
        })
        .catch(_ => {})
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.categoryForm.file = this.needUrl
          this.$axios
            .post('api/advice/store', this.categoryForm)
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$refs.categoryForm.resetFields()
                this.$refs.uploadMutiple.clearFiles()
                this.needUrl = []
                this.$message.success(data.msg)
                this.categoryIndrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          return false
        }
      })
    },
    editSubmitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var oldId = this.editFileList.map(item => {
            return item.id
          })
          this.$axios
            .put('api/advice/edit', {
              id: this.category,
              ideCateId: this.ideCateId,
              cateId: this.categoryEditForm.categoryId,
              body: this.categoryEditForm.body,
              oldId: oldId,
              change: this.change,
              newFile: this.editNeedUrl
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.editNeedUrl = []
                this.editFileList = []
                this.change = false
                this.$message.success(data.msg)
                this.categoryEditDrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getRole () {
      this.$axios
        .get('api/advice/role')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.roleOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    getCate () {
      this.$axios
        .get('api/advice/cate')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.cateOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    getCateEdit () {
      this.$axios
        .get('api/advice/cate')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.cateEditOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    readRecord (row) {
      let newPage = this.$router.resolve({
        path: '/documentation',
        query: { url: row.body }
      })
      window.open(newPage.href, '_blank')

      this.$axios
        .post('api/advice/readrecord', {
          id: row.id,
          title: row.title
        })
        .then(({ data }) => {
          if (data.code === 1) {
            // this.comNoticeData = data.data.data
            // this.total = data.data.total
          }
        })
        .catch()
    },
    searchRemoteCompanyMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        this.searchArrItemCompanys(query)
        setTimeout(() => {
          this.searchLoading = false
        }, 200)
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompanies = data.data.companies
        }
      })
    },
    searchRemoteCompanyMethodS (query) {
      if (query !== '') {
        this.searchLoading = true
        this.searchArrItemCompanysx(query)
        setTimeout(() => {
          this.searchLoading = false
        }, 200)
      } else {
        this.searchCompaniesx = []
      }
    },
    searchArrItemCompanysx (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompaniesx = data.data.companies
        }
      })
    },
    // 监听粘贴操作
    handlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return
      }
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
        return
      }
      this.$refs.uploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit() // 提交图片上传队列
    },

    handleRemove (file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1)
        }
      })
      this.fileList = fileList
    },

    handlePictureCardPreview (file) {
      this.dialogVisible = true
      this.dialogImageUrl = file.url
    },
    handleAvatarSuccess (res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    handleAvatarChange (res, file) {
      this.fileList = file
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片格式为JPG或PNG!')
        return
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      // return isJPG && isLt2M
    },
    editHandlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return
      }
      if (this.editFileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
        return
      }
      this.$refs.editUploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.editUploadMutiple.submit() // 提交图片上传队列
    },

    editHandleRemove (file, fileList) {
      // this.editFileList.map((item, index) => {
      //   if (item.uid === file.uid) {
      //     this.editFileList.splice(index, 1)
      //   }
      // })
      this.editFileList = fileList
      this.change = true
    },

    editHandlePictureCardPreview (file) {
      this.dialogVisibleE = true
      this.dialogImageUrlE = file.url
    },
    editHandleAvatarSuccess (res, file) {
      if (res.code === 1) {
        this.editNeedUrl.push({ url: res.url, name: file.name })
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    editHandleAvatarChange (res, file) {
      this.editFileList = file
      this.change = true
    },
    editBeforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片格式为JPG或PNG!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    openCompanyCom (row) {
      this.companyInfoDrawer = true
      setTimeout(() => {
        this.companyComId = row.companyId
      })
    },
    resetForm (formName) {
      this.visible = false
      this.$refs[formName].resetFields()
    },
    doSearch () {
      this.visible = false
      this.loadTable()
    },
    toSearch (val) {
      this.loadTable()
    },
    setRow (evt, row) {
      this.$axios
        .put('api/advice/setas', {
          id: row.id,
          is_use: evt
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.loadTable()
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    cancelSetRow (row) {
      //
    },
    getWonderful () {
      this.$axios
        .get('api/advice/wonderfullist')
        .then(({ data }) => {
          if (data.code === 1) {
            this.wonderfulData = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    getAgree () {
      this.$axios
        .get('api/advice/agreelist')
        .then(({ data }) => {
          if (data.code === 1) {
            this.agreeData = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    submitOM (val) {
      this.loadTable()
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  }
}
</script>
<style  scoped>
.advice {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 15px;
  text-align: right;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/advice/Advice.vue